import map from 'lodash/map'
import { Dropdown } from 'react-bootstrap'
import { Field, FormModal } from '@ztechapps/webui.form'
import { TextAreaInput } from '@ztechapps/webui.input'
import { Alert } from '@ztechapps/webui.util'
import { useConversationInboxContext } from './Context'
import { useConversationBatchActions } from './useConversationBatchActions'

type BatchRemarksFormValues = { remarks: string }
const initialValues: BatchRemarksFormValues = { remarks: '' }

export const BatchRemarksModal = () => {
  const { chatListWithSelection } = useConversationInboxContext()
  const { selectedList } = chatListWithSelection
  const { updateRemarks } = useConversationBatchActions()

  const onSubmit = async (values: BatchRemarksFormValues) => {
    await updateRemarks(map(selectedList, '_id'), values.remarks)
  }

  return (
    <FormModal<BatchRemarksFormValues>
      trigger={({ onClick }) => <Dropdown.Item onClick={onClick}>Set remarks</Dropdown.Item>}
      initialValues={initialValues}
      onSubmit={onSubmit}
      title="Set remarks"
      saveText="Set remarks"
      saveCancelButtonsProps={{ saveTitle: 'Set remarks', cancelTitle: 'Cancel without changing remarks' }}
    >
      <Field
        name="remarks"
        label="Remarks"
        component={TextAreaInput}
        rows={3}
        help="Replaces the remarks on every selected conversation. Empty text clears them."
        showHelpAsInline
      />
      <Alert type="info">
        Applies to <b>{selectedList.length}</b> selected conversation(s).
      </Alert>
    </FormModal>
  )
}
